import { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";

import { Page } from "@digital-services/shell";

import {
  BreadCrumbItem,
  CustomBreadCrumb
} from "@components/BreadCrumb/CustomBreadCrumb";

import { CreateOrganizationButton } from "@organization/components/CreateOrganizationButton";
import { OrganizationsOverview } from "@organization/components/OrganizationsOverview";

import { useUserContext } from "@hooks/useUserContext";

export const OrganizationsOverviewPage: FunctionComponent = () => {
  const { user } = useUserContext();
  const { t: tCommon } = useTranslation();
  const { t } = useTranslation(undefined, { keyPrefix: "organizations" });

  const breadCrumbs: BreadCrumbItem[] = [
    {
      name: tCommon("home.nav_item.label"),
      url: "/"
    },
    {
      name: tCommon("organizations.nav_item.label")
    }
  ];

  return (
    <Page title={t("page_title")}>
      <div className="flex justify-between">
        <CustomBreadCrumb breadCrumbs={breadCrumbs} />
        {user.isSuperAdmin ? <CreateOrganizationButton /> : null}
      </div>

      <div
        className="flex flex-col"
        data-testid="organization-overview-content"
      >
        <OrganizationsOverview />
      </div>
    </Page>
  );
};
